import { render, staticRenderFns } from "./m_index.vue?vue&type=template&id=48bb2f06&scoped=true&"
import script from "./m_index.vue?vue&type=script&lang=js&"
export * from "./m_index.vue?vue&type=script&lang=js&"
import style0 from "./m_index.vue?vue&type=style&index=0&id=48bb2f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb2f06",
  null
  
)

export default component.exports